import { ReactNode } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { DraggableModalDialog } from '../Dialogs/DraggableModalDialog';

interface LBMModalProps {
    showDialog: boolean,
    closeDialog: () => void,
    titleTranslationKey: string,
    size?: 'sm' | 'lg' | 'xl', // default is 'md' so doesn't need to be specified
    className?:string,
    children?: ReactNode,
    footerComponent?: ReactNode,
}

function LBMModal(props: LBMModalProps) {
    const { t } = useTranslation();

    return (
        <Modal
            dialogAs={DraggableModalDialog}
            show={props.showDialog}
            onHide={props.closeDialog}
            backdrop="static"
            className={props.className}
            size={props.size}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    {t<string>(props.titleTranslationKey)}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.children}
            </Modal.Body>
            {props.footerComponent && 
                <Modal.Footer>
                    {props.footerComponent}
                </Modal.Footer>
            }
        </Modal>
    );
}

export default LBMModal;